import React from "react";
import Header from "../components/header/Header";
import FloatingButton from "../components/bottomtotop/FloatingButton";
import Footer from "../components/footer/Footer";
import seller_image from "../../assets/Docs/seller_image.png";
import buyer_images from "../../assets/Docs/buyer_images.png";
import {
  FaBoxOpen,
  FaClipboardList,
  FaClock,
  FaDatabase,
  FaGlobe,
  FaHourglassHalf,
  FaListUl,
  FaTruck,
  FaUsers,
} from "react-icons/fa6";
import {
  FaCheckCircle,
  FaCogs,
  FaMobileAlt,
  FaShoppingCart,
  FaSmile,
} from "react-icons/fa";

const Application = () => {
  const features5 = [
    {
      icon: <FaClock />,
      title: "Instant Setup",
      desc: "Get up & running in days rather than waiting for weeks or months for the development of your own app.",
    },
    {
      icon: <FaMobileAlt />,
      title: "Try Before You Buy",
      desc: "With our free forever plan, you can thoroughly try the platform before opting for custom branding.",
    },
    {
      icon: <FaMobileAlt />,
      title: "Web, Android ",
      desc: "Offer your sales reps & customers a full-featured B2B Ordering App for Web & Mobile.",
    },
    {
      icon: <FaListUl />,
      title: "50+ Features",
      desc: "Our B2B Ordering Platform is full-featured & new features are being added constantly to improve workflow.",
    },
    {
      icon: <FaGlobe />,
      title: "Trusted Worldwide",
      desc: "Hundreds of sellers worldwide rely on our B2B Ordering Platform to process thousands of orders every day.",
    },
    {
      icon: <FaDatabase />,
      title: "Data Backup & Security",
      desc: "Secure & highly available, backed by industry-leading cloud servers.",
    },
    {
      icon: <FaUsers />,
      title: "Experienced Team",
      desc: "Our team has over a decade of experience in design & development.",
    },
    {
      icon: <FaSmile />,
      title: "User Friendly",
      desc: "Designed to be user-friendly for all types of users & industries.",
    },
    {
      icon: <FaCogs />,
      title: "API Integration",
      desc: "Easily integrate our B2B Ordering Platform with your favorite ERP & Accounting systems.",
    },
  ];

  return (
    <div>
      <Header />
      <section>
        <div className="mx-auto max-w-7xl pt-8 md:pt-8 lg:pt-8 py-12 sm:py-16 lg:py-20 px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col items-center justify-center gap-3 sm:gap-4 lg:gap-6">
            <div className="animate-y flex flex-col text-center items-center gap-2 sm:gap-3 lg:gap-6">
              <h1 className="max-w-[280px] xs:max-w-[350px] sm:max-w-[500px] lg:max-w-[890px] text-2xl xs:text-3xl sm:text-4xl lg:text-6xl font-semibold text-gray-700 mb-1 sm:mb-2 lg:mb-3">
                Selzor's App
              </h1>
              <p className="max-w-[280px] xs:max-w-[343px] lg:max-w-6xl text-gray-600 text-base xs:text-lg sm:text-xl">
                Our B2B Buyer-Seller Application is designed to simplify
                business transactions and create stronger connections between
                buyers and sellers. The app integrates seamlessly with the
                website, allowing users to access real-time data including
                orders, products, requests, and updates—all in one place.
              </p>
            </div>
          </div>

          <section className="relative py-20 ">
            <div className="max-w-7xl mx-auto px-6 lg:px-12">
              {/* Heading */}
              <div className="text-center mb-16">
                <h2 className="text-4xl md:text-5xl font-bold text-[#1a9588] tracking-tight">
                  Key Features
                </h2>
                <p className="mt-4 text-lg text-[#1a9588]/80">
                  Empowering businesses with seamless tools and connectivity
                </p>
              </div>

              {/* Features Grid */}
              <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-10">
                {features5.map((feature, idx) => (
                  <div
                    key={idx}
                    className="group relative bg-white rounded-2xl p-8 text-center shadow-lg hover:shadow-xl transition-all duration-500 hover:-translate-y-3 border border-[#1a9588]/20"
                  >
                    {/* Icon Circle */}
                    <div
                      className={`mx-auto mb-6 w-16 h-16 flex items-center justify-center rounded-full bg-[#1a9588] text-white text-3xl shadow-lg group-hover:scale-110 group-hover:shadow-[0_0_25px_#1a9588aa] transition-all duration-500`}
                    >
                      {feature.icon}
                    </div>

                    <h3 className="text-xl font-semibold mb-3 text-[#1a9588]">
                      {feature.title}
                    </h3>
                    <p className="text-[#1a9588]/80 leading-relaxed text-sm">
                      {feature.desc}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </section>
        </div>
      </section>

      <div className="px-4 sm:px-6 lg:px-12 py-12 space-y-20">
        {/* Seller Dashboard Slide */}
        <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-10 items-center bg-gradient-to-r from-[#e6fffb] via-[#dbf4f1] to-[#c2f0ea] rounded-3xl shadow-xl hover:shadow-2xl p-6 md:p-10 transition-all duration-500">
          {/* Left Image */}
          <div>
            <img
              src={seller_image}
              alt="Seller Dashboard"
              className="rounded-2xl border-4 border-transparent  p-1  transition-transform duration-700 ease-in-out w-full"
            />
          </div>

          {/* Right Content */}
          <div className="text-[#1a9588] space-y-6">
            <h2 className="text-3xl md:text-4xl font-bold bg-gradient-to-r from-[#1a9588] to-[#16a085] text-transparent bg-clip-text">
              🛒 Seller Dashboard
            </h2>
            <p className="text-base md:text-lg leading-relaxed text-gray-700">
              Manage all your orders, users, distributors, and requests in one
              place. Stay in control of your business with real-time updates.
            </p>

            <div className="space-y-4">
              <h3 className="text-xl font-semibold">Key Modules:</h3>
              <ul className="space-y-3 text-sm md:text-base">
                <li className="flex gap-3 items-center hover:translate-x-2 hover:text-[#16a085] transition-all">
                  <span className="p-2 bg-[#1a9588]/10 rounded-full">
                    <FaClipboardList />
                  </span>
                  Total Orders & Available Orders
                </li>
                <li className="flex gap-3 items-center hover:translate-x-2 hover:text-[#16a085] transition-all">
                  <span className="p-2 bg-[#1a9588]/10 rounded-full">
                    <FaUsers />
                  </span>
                  Users
                </li>
                <li className="flex gap-3 items-center hover:translate-x-2 hover:text-[#16a085] transition-all">
                  <span className="p-2 bg-[#1a9588]/10 rounded-full">
                    <FaTruck />
                  </span>
                  Distributors
                </li>
                <li className="flex gap-3 items-center hover:translate-x-2 hover:text-[#16a085] transition-all">
                  <span className="p-2 bg-[#1a9588]/10 rounded-full">
                    <FaHourglassHalf />
                  </span>
                  Pending Requests
                </li>
              </ul>
            </div>

            <div className="space-y-4">
              <h3 className="text-xl font-semibold">Order Management:</h3>
              <ul className="space-y-3 text-sm md:text-base grid grid-cols-2">
                <li className="flex gap-3 items-center hover:translate-x-2 hover:text-[#16a085] transition-all">
                  <span className="p-2 bg-[#1a9588]/10 rounded-full">
                    <FaShoppingCart />
                  </span>
                  New Orders
                </li>
                <li className="flex gap-3 items-center hover:translate-x-2 hover:text-[#16a085] transition-all">
                  <span className="p-2 bg-[#1a9588]/10 rounded-full">
                    <FaCheckCircle />
                  </span>
                  Confirmed Orders
                </li>
                <li className="flex gap-3 items-center hover:translate-x-2 hover:text-[#16a085] transition-all">
                  <span className="p-2 bg-[#1a9588]/10 rounded-full">
                    <FaHourglassHalf />
                  </span>
                  Orders On Hold
                </li>
                <li className="flex gap-3 items-center hover:translate-x-2 hover:text-[#16a085] transition-all">
                  <span className="p-2 bg-[#1a9588]/10 rounded-full">
                    <FaClipboardList />
                  </span>
                  Orders Processing
                </li>
                <li className="flex gap-3 items-center hover:translate-x-2 hover:text-[#16a085] transition-all">
                  <span className="p-2 bg-[#1a9588]/10 rounded-full">
                    <FaBoxOpen />
                  </span>
                  Completed Orders
                </li>
                <li className="flex gap-3 items-center hover:translate-x-2 hover:text-[#16a085] transition-all">
                  <span className="p-2 bg-[#1a9588]/10 rounded-full">
                    <FaTruck />
                  </span>
                  Delivered Orders
                </li>
              </ul>
            </div>
          </div>
        </div>




        {/* Buyer Dashboard Slide */}
        <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-10 items-center bg-gradient-to-r from-[#e6fffb] via-[#dbf4f1] to-[#c2f0ea] rounded-3xl shadow-xl hover:shadow-2xl p-6 md:p-10 transition-all duration-500">
          {/* Left Content */}
          <div className="text-[#1a9588] space-y-6 order-2 md:order-1">
            <h2 className="text-3xl md:text-4xl font-bold bg-gradient-to-r from-[#1a9588] to-[#16a085] text-transparent bg-clip-text">
              🛍️ Buyer Dashboard
            </h2>
            <p className="text-base md:text-lg leading-relaxed text-gray-700">
              Track your total orders, manage suppliers, and handle requests
              directly from your dashboard. Simplify your purchasing process
              with complete visibility.
            </p>

            <div className="space-y-4">
              <h3 className="text-xl font-semibold">Key Modules:</h3>
              <ul className="space-y-3 text-sm md:text-base">
                <li className="flex gap-3 items-center hover:translate-x-2 hover:text-[#16a085] transition-all">
                  <span className="p-2 bg-[#1a9588]/10 rounded-full">
                    <FaClipboardList />
                  </span>
                  Total Orders
                </li>
                <li className="flex gap-3 items-center hover:translate-x-2 hover:text-[#16a085] transition-all">
                  <span className="p-2 bg-[#1a9588]/10 rounded-full">
                    <FaUsers />
                  </span>
                  Users
                </li>
                <li className="flex gap-3 items-center hover:translate-x-2 hover:text-[#16a085] transition-all">
                  <span className="p-2 bg-[#1a9588]/10 rounded-full">
                    <FaTruck />
                  </span>
                  Suppliers
                </li>
                <li className="flex gap-3 items-center hover:translate-x-2 hover:text-[#16a085] transition-all">
                  <span className="p-2 bg-[#1a9588]/10 rounded-full">
                    <FaHourglassHalf />
                  </span>
                  Pending Requests
                </li>
              </ul>
            </div>

            <div className="space-y-4">
              <h3 className="text-xl font-semibold">Order Management:</h3>
              <ul className="space-y-3 text-sm md:text-base grid grid-cols-2">
                <li className="flex gap-3 items-center hover:translate-x-2 hover:text-[#16a085] transition-all">
                  <span className="p-2 bg-[#1a9588]/10 rounded-full">
                    <FaShoppingCart />
                  </span>
                  New Orders
                </li>
                <li className="flex gap-3 items-center hover:translate-x-2 hover:text-[#16a085] transition-all">
                  <span className="p-2 bg-[#1a9588]/10 rounded-full">
                    <FaCheckCircle />
                  </span>
                  Confirmed Orders
                </li>
                <li className="flex gap-3 items-center hover:translate-x-2 hover:text-[#16a085] transition-all">
                  <span className="p-2 bg-[#1a9588]/10 rounded-full">
                    <FaHourglassHalf />
                  </span>
                  Orders On Hold
                </li>
                <li className="flex gap-3 items-center hover:translate-x-2 hover:text-[#16a085] transition-all">
                  <span className="p-2 bg-[#1a9588]/10 rounded-full">
                    <FaClipboardList />
                  </span>
                  Orders Processing
                </li>
                <li className="flex gap-3 items-center hover:translate-x-2 hover:text-[#16a085] transition-all">
                  <span className="p-2 bg-[#1a9588]/10 rounded-full">
                    <FaBoxOpen />
                  </span>
                  Completed Orders
                </li>
                <li className="flex gap-3 items-center hover:translate-x-2 hover:text-[#16a085] transition-all">
                  <span className="p-2 bg-[#1a9588]/10 rounded-full">
                    <FaTruck />
                  </span>
                  Delivered Orders
                </li>
              </ul>
            </div>
          </div>

          {/* Right Image */}
          <div className="order-1 md:order-2">
            <img
              src={buyer_images}
              alt="Buyer Dashboard"
              className="rounded-2xl border-4 border-transparent  p-1   transition-transform duration-700 ease-in-out w-full"
            />
          </div>
        </div>
      </div>

      <FloatingButton />
      <Footer />
    </div>
  );
};

export default Application;
